import { AIR_API_CONFIG } from '../constants/airApiConfig';
import { ANONYMOUS_COGNITO_CONFIG } from '../constants/cognitoConfig';
import { ANONYMOUS_OAUTH_CONFIG } from '../constants/oauthConfig';
import { type DeepPartial } from '../types/DeepPartial';
import { type ConfigureAPIPackageParams, configureAPIPackage } from './configureAPIPackage';

export const configureAPIPackageForAnonymousSignUp = (params?: DeepPartial<ConfigureAPIPackageParams>) =>
  configureAPIPackage({
    baseUrl: AIR_API_CONFIG.baseUrl,
    cognitoConfigParams: ANONYMOUS_COGNITO_CONFIG,
    oauthConfigParams: ANONYMOUS_OAUTH_CONFIG,
    ...params,
  });
